'use client';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import CCPALink from '@/components/CCPALink';

export default function Footer() {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    services: [
      { label: 'Jak fungujeme', href: '/how-we-work' },
      { label: 'Online diagnóza', href: '/online-initial-diagnosis' },
      { label: 'Finanční plán', href: '/financial-plan' },
      { label: 'První schůzka', href: '/first-meeting-analysis' }
    ],
    legal: [
      { label: 'Zásady ochrany osobních údajů', href: '/privacy' },
      { label: 'Zásady cookies', href: '/zasady-cookies' }
    ]
  };

  const handleCookiePreferences = () => {
    // Trigger cookie preferences modal
    const event = new CustomEvent('openCookiePreferences');
    window.dispatchEvent(event);
  };

  return (
    <footer className="bg-brand-primary text-white py-12 lg:py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/assets/images/logo_-_transpar-1777541518906.png"
                alt="Co-Work logo"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-white/80 mb-4">
              Váš finanční partner pro dlouhodobý růst a stabilitu v Praze.
            </p>
            <div className="flex items-center space-x-2 text-accent">
              <Icon name="MapPinIcon" size={20} className="text-current" variant="solid" />
              <span className="text-sm">Praha-Chodov</span>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Služby</h3>
            <ul className="space-y-2">
              {footerLinks?.services?.map((link, index) => (
                <li key={index}>
                  <Link
                    href={link?.href}
                    className="text-white/80 hover:text-accent transition-smooth"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Icon name="PhoneIcon" size={20} className="text-accent flex-shrink-0" />
                <a href="tel:+420603349664" className="text-white/80 hover:text-accent transition-smooth">
                  +420 603 349 664
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Icon name="EnvelopeIcon" size={20} className="text-accent flex-shrink-0" />
                <a href="mailto:radek.havranek@co-work.cz" className="text-white/80 hover:text-accent transition-smooth">
                  radek.havranek@co-work.cz
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Icon name="ClockIcon" size={20} className="text-accent flex-shrink-0" />
                <span className="text-white/80">Po-Pá 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-white/60">
              &copy; {currentYear} Co-Work Financial Partners. Všechna práva vyhrazena.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
              {footerLinks?.legal?.map((link, index) => (
                <Link
                  key={index}
                  href={link?.href}
                  className="text-sm text-white/60 hover:text-accent transition-smooth"
                >
                  {link?.label}
                </Link>
              ))}
              <button
                onClick={handleCookiePreferences}
                className="text-sm text-white/60 hover:text-accent transition-smooth bg-none border-none cursor-pointer p-0"
              >
                Cookie Preferences
              </button>
              <CCPALink />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}